module.exports = __webpack_public_path__ + "static/img/quanmin03_btn.d0a8793c.png";